
import SectionParkingV1 from './parking/SectionParkingV1'
import SectionParkingV2 from './parking/SectionParkingV2'
import SectionParkingV3 from './parking/SectionParkingV3'
import SectionParkingV4 from './parking/SectionParkingV4'
export default {
  name: 'SectionParking',
  props: {
    variant: {
      required: true,
      type: String,
      default: ''
    },
    data: {
      required: true,
      type: Object | Array,
      default: function () {
        return {}
      }
    },
    orderNo: {
      required: true,
      type: Number,
      default: 0
    },
    hash: {
      required: true,
      type: String,
      default: ''
    }
  },
  data() {
    return {
      componentVariant: null
    }
  },
  watch: {
    variant: function (newVariant, oldVariant) {
      this.handleVariant(newVariant)
    }
  },
  created() {
    this.handleVariant(this.variant)
  },
  methods: {
    handleVariant(variant) {
      switch (variant) {
        case 'v4':
          this.componentVariant = SectionParkingV4
          break
        case 'v3':
          this.componentVariant = SectionParkingV3
          break
        case 'v2':
          this.componentVariant = SectionParkingV2
          break
        default:
          this.componentVariant = SectionParkingV1
          break
      }
    }
  }
}
